/**
=========================================================
* ooGoal - v5.0.0
=========================================================

* Product Page: https://oogoal.com
* Copyright 2022 Onza Technologies

=========================================================

* The above copyright must be included
*/

import { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Switch from "@mui/material/Switch";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import OGBox from "assets/theme/components/OGBox";
import OGTypography from "assets/theme/components/OGTypography";
import Breadcrumbs from "assets/theme/components/OGBreadcrumbs";
import Tooltip from "@mui/material/Tooltip";
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarIconMenu,
} from "assets/theme/components/OGNavbars/DashboardNavbar/styles";
import { useThemeUIController, setCollapseSidenav, setDarkMode } from "context";
import MyProfile from "@mui/icons-material/AccountCircle";
import MenuOpen from "@mui/icons-material//MenuOpen";
import Menu from "@mui/icons-material//Menu";
import MyNotification from "@mui/icons-material//Notifications";

function DashboardNavbar({ absolute, isCollapse }) {
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useThemeUIController();
  const { collapseSidenav, fixedNavbar, darkMode } = controller;
  const route = useLocation().pathname.split("/").slice(1);

  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }
  }, [dispatch, fixedNavbar]);

  const handleCollapseSidenav = () => setCollapseSidenav(dispatch, !collapseSidenav);
  const handleDarkMode = () => {
    setDarkMode(dispatch, !darkMode);
  };

  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      sx={(theme) => navbar(theme, { absolute, darkMode })}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        <OGBox
          color="inherit"
          mb={{ xs: 1, md: 0 }}
          sx={(theme) => navbarRow(theme, { isCollapse })}
        >
          <Breadcrumbs
            icon="hub"
            title={route[route.length - 1]}
            route={route}
            darkMode={darkMode}
          />
        </OGBox>
        {isCollapse ? null : (
          <OGBox sx={(theme) => navbarRow(theme, { isCollapse })}>
            <OGBox display="flex" justifyContent="space-evenly" alignItems="center" lineHeight={1}>
              <OGBox>
                <Switch checked={darkMode} onChange={handleDarkMode} />
              </OGBox>
              <OGBox>
                <OGTypography variant="caption"> Will be back soon! </OGTypography>
                <Tooltip title="profile">
                  <IconButton
                    disableRipple
                    sx={(theme) => navbarIconButton(theme, { darkMode, size: "medium" })}
                  >
                    <Link to="/profile">
                      <MyProfile>user</MyProfile>
                    </Link>
                  </IconButton>
                </Tooltip>
                <Tooltip title="Notification">
                  <Badge badgeContent={0} overlap="circular">
                    <IconButton
                      disableRipple
                      sx={(theme) => navbarIconButton(theme, { darkMode, size: "medium" })}
                    >
                      <Link to="/profile">
                        <MyNotification>notification</MyNotification>
                      </Link>
                    </IconButton>
                  </Badge>
                </Tooltip>
              </OGBox>
            </OGBox>
            <OGBox display="flex" justifyContent="space-evenly" alignItems="center" lineHeight={1}>
              <IconButton
                disableRipple
                color="inherit"
                sx={(theme) => navbarIconMenu(theme, { darkMode, size: "medium" })}
                onClick={handleCollapseSidenav}
              >
                {collapseSidenav ? <MenuOpen>menuopen</MenuOpen> : <Menu>menu</Menu>}
              </IconButton>
            </OGBox>
          </OGBox>
        )}
      </Toolbar>
    </AppBar>
  );
}

DashboardNavbar.defaultProps = {
  absolute: false,
  isCollapse: false,
};

DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  isCollapse: PropTypes.bool,
};

export default DashboardNavbar;
